import React, {useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Button, Card, CardBody, CardFooter} from 'reactstrap';
import {loginMethod, setUserData} from '../../services/fetcher';
import {toastError} from '../../utils/ToastConfig';
import CustomModalDoubleAuthFactor from "../../components/CustomModals/CustomModalDoubleAuthFactor";
import {BASE_URL} from "../../config";
import {getOrCreateDeviceId} from "../../utils";
import { WITH_RECOVERY_PASSWORD } from '../../config';
import RecoverPassword from './RecoverPassword';

export default function Login(props) {
    const [loginData, setLoginData] = useState({});
    const [loginFailed, setLoginStatus] = useState(false);
	const [recoverPasswordView, setRecoverPasswordView] = useState(false);
    const [t] = useTranslation('app');
    const logo = process.env.REACT_APP_IMAGE_BAR;

    const [isDoubleAuthModalVisisble, setIsDoubleAuthModalVisible] = useState(false);
    const [accessData, setAccessData] = useState({});
    const [doubleAuthMessage, setDoubleAuthMessage] = useState('');
    const toggleDoubleAuthModal = () => setIsDoubleAuthModalVisible(prevState => !prevState);

    const handleChange = ({target: {value, name}}) => {
        setLoginData((prev) => {
            return {
                ...prev,
                [name]: value
            };
        });
    };

    const check_device = async (userInfo) => {
        const params = {
            method: 'POST',
            body: JSON.stringify({username: loginData.username}),
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: `Bearer ${userInfo.access}`,
            }
        };
        try {
            const response = await fetch(`${BASE_URL}/persons/double-factor/check-device/`, params);
            const data = await response.json();
            console.log(data);
            if (data.pass) {
                setUserData(userInfo);
                setLoginStatus(false);
                return;
            }
            setDoubleAuthMessage(data.message);
            toggleDoubleAuthModal();
        } catch (e) {
            toastError('Acceso no autorizado!');
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault();
        const userInfo = await loginMethod(loginData);
        if (userInfo && typeof userInfo === 'object' && userInfo.login) {
            setAccessData(userInfo);
            const useDoubleAuth = process.env.REACT_APP_USE_DOUBLE_AUTH;
            if (useDoubleAuth === "true") {
                check_device(userInfo).finally(() => undefined);
            } else {
                setLoginStatus(false);
            }
        } else {
            if (!userInfo) setLoginStatus(true);
            else toastError('Acceso no autorizado!');
        }
    };

	const recoverPassword = async (e) => {
		e.preventDefault();
		setRecoverPasswordView((prev) => !prev)
	}

    return (
        <form onSubmit={onSubmit}>
            <div className="Login">
                <div className="container">
                    <div className="Login-wrapper">
                        <Card className="Login-card">
                        {!recoverPasswordView ? <CardBody className="Login-content">
								<img className="Login-logo" src={logo} alt="logo" />
								<input
									className="Login-input"
									type="text"
									placeholder={t('login.user')}
									name="username"
									onChange={handleChange}
								/>
								<input
									className="Login-input"
									type="password"
									placeholder={t('login.password')}
									name="password"
									onChange={handleChange}
								/>
								{loginFailed ? <p>{t('login.loginError')}</p> : null}
								<Button className="Login-btn" type="submit">
									{t('login.login')}
								</Button>
							</CardBody> : <RecoverPassword />}
                            {WITH_RECOVERY_PASSWORD && <CardFooter className="Login-footer p-2 text-center">
								<a className='Login-link' href='javascript(0)' onClick={recoverPassword}>{recoverPasswordView ? t('goBack') : t('login.password_recovery.label')}</a>
							</CardFooter>}
                        </Card>
                    </div>
                </div>
            </div>
            <CustomModalDoubleAuthFactor
                toggle={toggleDoubleAuthModal}
                open={isDoubleAuthModalVisisble}
                accessData={accessData}
                username={loginData.username}
                message={doubleAuthMessage}
            />
        </form>
    );
}
